import script from "./VideoView.vue?vue&type=script&setup=true&lang=js"
export * from "./VideoView.vue?vue&type=script&setup=true&lang=js"

import "./VideoView.vue?vue&type=style&index=0&id=ce084848&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ce084848"]])

export default __exports__